/**
 * API Client Factory
 * Selects the appropriate adapter based on environment variable
 * 
 * Usage:
 *   import { api } from '@/lib/api';
 *   const products = await api.products.getProducts();
 * 
 * Environment:
 *   NEXT_PUBLIC_DATA_SOURCE=mock (default) | http
 *   NEXT_PUBLIC_API_BASE_URL= (required when using http)
 */

import mockClient from './adapters/mockClient';
import httpClient from './adapters/httpClient';
import type { ApiClient } from './client';

const dataSource = process.env.NEXT_PUBLIC_DATA_SOURCE || 'mock';

export const api: ApiClient = dataSource === 'http' ? httpClient : mockClient;

// Export types for convenience
export type { ApiClient } from './client';
export type { Product, Category, Shop, Order, OrderStatus, Cart, CartItem, User, UserRole } from './types';

